import tokenData from '../../design-tokens/base-tokens.json';
export const MuiTable = {
    styleOverrides: {
        root: {
            '&.OclcTable-striped': {
                '& .MuiTableRow-root': {
                    '&:nth-of-type(even)': {
                        background: tokenData.tokens.palette.background.snow,
                        '&.Mui-selected': {
                            background: tokenData.tokens.palette.background.snow
                        }
                    }
                },
                '& .MuiTableBody-root': {
                    '& .MuiTableRow-root': {
                        '&:nth-of-type(odd)': {
                            background: tokenData.tokens.palette.background.white,
                            '&.Mui-selected': {
                                background: tokenData.tokens.palette.background.white
                            }
                        }
                    }
                },
                '& .OclcTableBody-collapsible': {
                    '&:nth-of-type(even)': {
                        background: tokenData.tokens.palette.background.snow,
                        '& .MuiTableRow-root': {
                            background: tokenData.tokens.palette.background.snow
                        }
                    },
                    '&:nth-of-type(odd)': {
                        background: tokenData.tokens.palette.background.white,
                        '& .MuiTableRow-root': {
                            background: tokenData.tokens.palette.background.white
                        }
                    }
                }
            }
        }
    }
};
export const MuiTableContainer = {
    styleOverrides: {
        root: {
            border: `1px solid ${tokenData.tokens.palette.grey.grey300}`,
            boxShadow: 'none'
        }
    }
};
export const MuiTableHead = {
    styleOverrides: {
        root: {
            background: tokenData.tokens.palette.darkBlue.darkBlue100,
            '& th': {
                '&:has(.Mui-focusVisible)': {
                    background: tokenData.tokens.palette.background.white,
                    outline: '2px solid #000',
                    outlineOffset: '-2px'
                }
            }
        }
    }
};
export const MuiTableCell = {
    defaultProps: {
        size: 'small'
    },
    styleOverrides: {
        root: ({ theme }) => ({
            fontWeight: 500,
            borderBottom: `1px solid ${tokenData.tokens.palette.grey.grey300}`,
            ...theme.typography.body1,
            '&.MuiTableCell-head': {
                ...theme.typography.labelLg,
                padding: theme.spacing(3, 4, 3, 6)
            },
            '&.MuiTablePagination-root': {
                fontSize: 14,
                borderBottom: 'none',
                padding: 0
            },
        }),
        sizeSmall: ({ theme }) => ({
            ...theme.typography.body1,
            padding: theme.spacing(2, 6)
        })
    }
};
export const MuiTableSortLabel = {
    styleOverrides: {
        root: {
            '&.MuiButtonBase-root': {
                color: `${tokenData.tokens.palette.text.text300} !important`
            },
            '&:hover': {
                '& .MuiTableSortLabel-icon': {
                    opacity: 1
                }
            }
        }
    }
};
export const MuiTableBody = {
    styleOverrides: {
        root: {
            position: 'relative',
            '&.OclcTableBody-collapsible': {
                '&:not(:last-child)': {
                    borderBottom: `1px solid ${tokenData.tokens.palette.grey.grey300}`
                },
                '& .MuiTableCell-root': {
                    borderBottom: 'none'
                },
                '&:has(.MuiCollapse-entered)': {
                    '&:before': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        borderLeft: `2px solid ${tokenData.tokens.palette.blue.blue500}`,
                        height: '100%'
                    }
                }
            },
            '& .MuiTableCell-paddingCheckbox': {
                borderBottom: 'none'
            }
        }
    }
};
export const MuiTablePagination = {
    defaultProps: {
        labelRowsPerPage: 'Page size'
    },
    styleOverrides: {
        root: {
            '& .MuiTablePagination-input': {
                marginRight: '24px'
            }
        },
        selectLabel: ({ theme }) => ({
            ...theme.typography.body1
        }),
        select: {
            fontSize: '0.875rem',
            color: tokenData.tokens.palette.blue.blue500,
            fontWeight: '600',
            marginLeft: 0
        },
        actions: {
            marginLeft: 8
        },
        displayedRows: ({ theme }) => ({
            ...theme.typography.body1
        })
    }
};
